import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { href: '/', label: '首页' },
  { href: '/reports', label: '已核实报道' },
  { href: '/submit', label: '我要爆料' },
  { href: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const isActive = (href: string) =>
    href === '/' ? location.pathname === '/' : location.pathname.startsWith(href);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled || menuOpen
          ? 'bg-background-50 border-b border-background-200'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 select-none">
          <span
            className="w-8 h-8 flex items-center justify-center rounded bg-primary-500 text-background-50 font-bold text-sm"
            aria-hidden="true"
          >
            17
          </span>
          <span className="font-heading font-bold text-lg text-foreground-950 tracking-tight">
            爆料
          </span>
          <span className="hidden sm:inline text-xs text-foreground-500 border-l border-background-300 pl-2 ml-1">
            线索征集 · 核实发布
          </span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`px-4 py-2 text-sm rounded-md transition-colors whitespace-nowrap ${
                isActive(link.href)
                  ? 'text-primary-600 font-semibold bg-primary-50'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/submit"
            className="ml-2 px-4 py-2 text-sm rounded-md bg-primary-500 text-background-50 font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <span className="w-4 h-4 inline-flex items-center justify-center mr-1">
              <i className="ri-send-plane-line text-xs" />
            </span>
            立即投稿
          </Link>
        </nav>

        {/* Mobile hamburger */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center text-foreground-700 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="展开菜单"
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`} />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <nav
          className="md:hidden bg-background-50 border-t border-background-200 px-4 pb-4 flex flex-col gap-1"
          aria-label="移动端导航"
        >
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`px-3 py-2.5 text-sm rounded-md transition-colors whitespace-nowrap ${
                isActive(link.href)
                  ? 'text-primary-600 font-semibold bg-primary-50'
                  : 'text-foreground-700'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/submit"
            className="mt-2 px-4 py-2.5 text-sm rounded-md bg-primary-500 text-background-50 font-semibold text-center whitespace-nowrap"
          >
            立即投稿
          </Link>
        </nav>
      )}
    </header>
  );
}